import api from './api'

export const telemetryService = {
  getAnalytics: async (period = '7d') => {
    const response = await api.get('/api/telemetry/analytics', {
      params: { period },
    })
    return response.data
  },
}
